import style from './index.module.scss';
import cn from 'classnames';
interface IProduct {
  id: string;
  productName: string;
}
interface IProps {
  productList: IProduct[];
  activeId: string;
  onClickTab: (activeId: string) => void;
  classNames?: string;
}
export default function IndexView(props: IProps) {
  const { productList, activeId, onClickTab, classNames } = props;
  return (
    <div className={cn(style.leftTabWrapper, !!classNames && classNames)}>
      <ul>
        {productList.map((item: any) => (
          <li className={activeId === item.id ? style.active : ''} key={item.id} onClick={() => onClickTab(item.id)}>
            <span className={'for-pc'}>{item.productName}</span>
            <span className={'for-mobile'}>{'' + item.productName.substr(0, 7)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
